import type { Args as BaseArgs } from 'webapp/components/templates/recommended-base';
import TemplatesPublicRecommendedBaseComponent from 'webapp/components/templates/recommended-base';

import type Template from 'webapp/models-custom/template';

export interface Args extends BaseArgs {
	showAlternateTitle?: boolean;
}

export default class TemplatesPublicRecommendedBoardsComponent<
	T extends Args,
> extends TemplatesPublicRecommendedBaseComponent<T> {
	redirectRoute = 'boards.public-templates.index';
	defaultOrigin = 'recommended_templates';

	get model(): Template[] {
		return this.mmTemplatesService.getRecommendedBoardPublicTemplateModels(this.maxItemsShown);
	}

	requestTemplates() {
		return this.mmTemplatesService.requestBoardPublicTemplates();
	}

	onTemplateUse(model: Template): void {
		this.onBoardTemplateUse(model);
	}
}
